import { useEffect, useState } from "react";
import { fetchCompaniesApi } from "../../services/axios/AuthApis/AdministrationApis";
import CompanyAutoComplete from "./CompanyAutoComplete";

const EndUserForm = ({ newUser, setNewUser, errors, setErrors, isEdit }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(newUser?.company || "");
  const [selectedCompany, setSelectedCompany] = useState([])
  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm.trim().length >= 2) {
        setLoading(true);
        fetchCompaniesApi(searchTerm)
          .then(data => {
            setCompanies(data.results);
            setLoading(false);
          })
          .catch(err => {
            console.error(err);
            setLoading(false);
          });
      } else {
        setCompanies([]);
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(true);
  };

  const handleSelectCompany = (company) => {
    setSelectedCompany(company);
    setSearchTerm(company.company_name);
    setShowDropdown(false);
    setNewUser({ ...newUser, company: company.company_name });
    setErrors(prev => ({ ...prev, company: undefined }));
  };
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* First Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">First Name <span className="text-red-500">*</span></label>
        <input
          type="text"
          maxLength={250}
          value={newUser.firstname}
          onChange={(e) => {
            setNewUser({ ...newUser, firstname: e.target.value });
            setErrors(prev => ({ ...prev, firstname: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.firstname ? "border-red-500" : "border-gray-300"
            }`}
          placeholder="Enter first name"
        />
        {errors.firstname && <p className="text-red-500 text-xs mt-1">{errors.firstname}</p>}
      </div>

      {/* Last Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Last Name </label>
        <input
          type="text"
          maxLength={250}
          value={newUser.lastname}
          onChange={(e) => {
            setNewUser({ ...newUser, lastname: e.target.value });
            setErrors(prev => ({ ...prev, lastname: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.lastname ? "border-red-500" : "border-gray-300"
            }`}
          placeholder="Enter last name"
        />
        {errors.lastname && <p className="text-red-500 text-xs mt-1">{errors.lastname}</p>}
      </div>


      {/* Company */}
      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Company <span className="text-red-500">*</span>
        </label>
        <CompanyAutoComplete
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          handleSelectCompany={handleSelectCompany}
          companies={companies}
          loading={loading}
          errors={errors}
          type="single-select"
          setShowDropdown={setShowDropdown}
          showDropdown={showDropdown}
        />
        {errors.company && (
          <p className="text-red-500 text-xs mt-1">{errors.company}</p>
        )}
      </div>


      {/* Email */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Email<span className="text-red-500">*</span></label>
        <input
          type="email"
          value={newUser.email}
          readOnly={isEdit}
          onChange={isEdit ? undefined : (e) => {
            setNewUser({ ...newUser, email: e.target.value });
            setErrors((prev) => ({ ...prev, email: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.email ? "border-red-500" : "border-gray-300"} ${isEdit ? "bg-gray-50 text-gray-500 cursor-not-allowed" : ""}`}
          placeholder="Enter email address"
        />
        {errors.email && (
          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
        )}
      </div>

      {/* Phone */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
        <input
          type="tel"
          maxLength={10}
          value={newUser.phone}
          onChange={(e) => {
            setNewUser({ ...newUser, phone: e.target.value });
            setErrors(prev => ({ ...prev, phone: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.phone ? "border-red-500" : "border-gray-300"
            }`}
          placeholder="Enter phone number"
        />
        {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
      </div>
      {/* Department */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Department</label>
        <input
          type="text"
          value={newUser.department}
          onChange={(e) => setNewUser({ ...newUser, department: e.target.value })}
          className="w-full border border-gray-300 rounded-lg px-3 py-2"
          placeholder="Enter department"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Reporting_to</label>
        <input
          type="text"
          value={newUser.reporting_to}
          onChange={(e) => setNewUser({ ...newUser, reporting_to: e.target.value })}
          className="w-full border border-gray-300 rounded-lg px-3 py-2"
          placeholder="Enter reporter name"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Date of Joining <span className="text-red-500">*</span>
        </label>
        <input
          type="date"
          value={newUser.date_of_joining || ""}
          onChange={(e) => {
            setNewUser({ ...newUser, date_of_joining: e.target.value });
            setErrors((prev) => ({ ...prev, date_of_joining: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.date_of_joining ? "border-red-500" : "border-gray-300"
            }`}
        />
        {errors.date_of_joining && (
          <p className="text-red-500 text-xs mt-1">{errors.date_of_joining}</p>
        )}
      </div>
    </div>
  );
};
export default EndUserForm;